import { Box, Typography } from "@mui/material";
import { motion, useScroll, useTransform } from "framer-motion";
import bannerImage from "../../assets/image/landing/banner.png";
import logo from "../../assets/logo/radix.png";
import { useState, useEffect } from "react";
import ParticleNetwork from "../animations/ParticleNetwork";

const HeroSectionComponent = () => {

    const { scrollY } = useScroll();
    const y = useTransform(scrollY, [0, 500], [0, 200]); // Move background down slower than scroll

    return (
        <Box sx={{ overflow: 'hidden', position: 'relative', minHeight: '100vh', bgcolor: '#000' }}>
            {/* Parallax Background */}
            <motion.div
                style={{
                    backgroundImage: `url(${bannerImage})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    height: '120%', // Taller to accommodate parallax movement
                    width: '100%',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    y: y, // Apply parallax y
                    zIndex: 0
                }}
            />

            {/* Particle Network Layer */}
            <Box sx={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 1 }}>
                <ParticleNetwork />
            </Box>

            {/* Glitch/Scanline Overlay */}
            <Box sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                background: 'linear-gradient(rgba(18, 16, 16, 0) 50%, rgba(0, 0, 0, 0.25) 50%), linear-gradient(90deg, rgba(255, 0, 0, 0.06), rgba(0, 255, 0, 0.02), rgba(0, 0, 255, 0.06))',
                backgroundSize: '100% 2px, 3px 100%',
                zIndex: 2,
                content: '""',
                pointerEvents: 'none'
            }} />

            <Box
                style={{
                    minHeight: '100vh',
                    width: '100%',
                    position: 'relative',
                    zIndex: 3
                }}
            >
                {/* Blue Overlay */}
                <Box sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(8, 36, 77, 0.6)', // Slightly reduced opacity
                    zIndex: -1
                }} />

                <Box className="containerMain"
                    sx={{
                        position: 'relative',
                        minHeight: '100vh',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        color: 'white',
                        px: { xs: 3, md: 0 },
                        pt: { xs: 12, md: 16 },
                        pb: 8
                    }}
                >
                    <motion.div
                        initial={{ opacity: 0, x: -50 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 1 }}
                    >
                        <Typography
                            variant="h1"
                            sx={{
                                fontWeight: 'bold',
                                fontSize: { xs: '2.5rem', md: '4rem' },
                                letterSpacing: 5,
                                mb: 2,
                                // borderLeft: '5px solid #4facfe', // Tech Accent
                                // pl: 1,
                                // fontFamily: "'Courier New', Courier, monospace", // Monospace for terminal feel
                                color: '#fff',
                                textShadow: '0 0 10px rgba(79, 172, 254, 0.5)',
                                textAlign: 'start'
                            }}
                        >
                            ABOUT US
                        </Typography>
                    </motion.div>
                    <Box
                        sx={{
                            width: { xs: '100%', md: '50%' },
                            textAlign: 'justify',
                            color: '#fff',
                            mt: 5
                        }}
                    >
                        <motion.div
                            initial={{ opacity: 0, y: 30 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.8, delay: 0.3, ease: "easeOut" }}
                        >
                            <Typography sx={{ mb: 4, fontSize: { xs: '1.1rem', md: '1.75rem' } }}>
                                Radix Group Inc. (RDX) is a security, technology, and infrastructure company in the Philippines. It collaborates with local and foreign partners to provide state-of-the-art solutions.
                            </Typography>
                        </motion.div>
                        <motion.div
                            initial={{ opacity: 0, y: 30 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.8, delay: 0.5, ease: "easeOut" }}
                        >
                            <Typography sx={{ mb: 4, fontSize: { xs: '1.1rem', md: '1.75rem' } }}>
                                RDX’s mission is to build a stronger and safer Philippines by delivering advanced security systems and improving infrastructure.
                            </Typography>
                        </motion.div>
                    </Box>

                    <motion.div
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 1, delay: 0.8, ease: "easeOut" }}
                        style={{ marginTop: 'auto' }}
                    >
                        <Typography sx={{ color: '#fff', mt: { xs: 6, md: 10 }, ml: { xs: 0, md: 8 }, fontSize: { xs: '1.25rem', md: '2.5rem' }, fontWeight: 'bold', textAlign: { xs: 'center', md: 'left' } }}>
                            “Building a Stronger and Safer Philippines.”
                        </Typography>
                    </motion.div>
                </Box>
            </Box>
        </Box>
    );
};

export default HeroSectionComponent;